import _ from 'lodash'

const local = window.location.hostname === 'localhost'
const dev   = window.location.hostname.startsWith('dev')
export const prefix   = '' //local ? 'local-' : dev ? 'dev-' : ''
export const host     = local ? 'http://localhost:9000' : dev ? 'https://api-dev.dogma.legal' : 'https://api.dogma.legal'
export const frontend = local ? 'http://localhost:5000' : dev ? 'https://dev.dogma.legal'     : 'https://console.dogma.legal'

export function delay(duration) {
    return value => {
        return new Promise( (resolve, reject) => {
            setTimeout(() => resolve(value), duration)
        })
    }
}

export function resolve(url) {
    const args = Array.prototype.slice.call(arguments);
    const path = args.join("/")
    return `${host}${path}`
}

export function get(url) {
    return exec(url, 'GET')
}

export function post(url, body, omit = true) {
    if(omit) {
        body = _.omitBy(body, i => i === '')
    }
    return exec(url, 'POST', body)
}

export function put(url, body) {
    return exec(url, 'PUT', body)
}

export function del(url, body) {
    return exec(url, 'DELETE', body)
}

export function exec(url, method, body) {
    const params = {
        method      : method,
        mode        : 'cors',
        cache       : 'no-cache',
        credentials : 'include'
    }

    if(body && (method === 'PUT' || method === 'POST')) {
        params.headers = { 'Content-Type': 'application/json' }
        params.body    = JSON.stringify(body)
    }

    return fetch(resolve(url), params)
}

export function toJsonIf200(res) {
    if(res.status === 200) {
        return res.json()           
    } else {
        return Promise.reject(res)
    }
}

export function toTextIf200(res) {
    if(res.status === 200) {
        return res.text()
    } else {
        return Promise.reject(res)
    }
}
